import FDataTableMDP, { ActionType } from "@/components/table/FDataTableMDP";
import FCellNumberMDP from "@/components/table/cell/FCellNumberMDP";

export default class FPPSalesManagerDashboardAgentPerformanceFDataTableMDP extends FDataTableMDP {
  parent: any;
  constructor(props: { parent: any }) {
    super({
      myRefName: "fppSalesManagerDashboardAgentPerformanceFDataTableRef",
      enableSearch: true,
      title: "Agents Performance",
      itemKey: "dsaUserName",
      enablePagination: true,
      enableExport: true,
      enableShowHideColumns: true,
      showFiltersByDefault: false,
    });
    
    this.parent = props.parent;

    this.addColumn({
      label: "Agent Name",
      dataSelectorKey: "dsaUserName",
      sortable: true,
      align: "left",
    })
      .addColumn({
        label: "Links Sent",
        dataSelectorKey: "linkSentCount",
        columnCellMDP: new FCellNumberMDP({ rounded: false }),
        sortable: true,
        align: "center",
      })
      .addColumn({
        label: "Signups",
        dataSelectorKey: "signUpCount",
        columnCellMDP: new FCellNumberMDP({ rounded: false }),
        sortable: true,
        align: "center",
      })
      .addColumn({
        label: "Credit Pulls",
        dataSelectorKey: "creditPullCount",
        columnCellMDP: new FCellNumberMDP({ rounded: false }),
        sortable: true,
        align: "center",
      })
      .addColumn({
        label: "Eligible",
        dataSelectorKey: "elgibileCount",
        columnCellMDP: new FCellNumberMDP({ rounded: false }),
        sortable: true,
        align: "center",
      })
      .addColumn({
        label: "Ineligible",
        dataSelectorKey: "inEligibleCount",
        columnCellMDP: new FCellNumberMDP({ rounded: false }),
        sortable: true,
        align: "center",
      })
      .addColumn({
        label: "Transferred",
        dataSelectorKey: "transferredCount",
        columnCellMDP: new FCellNumberMDP({ rounded: false }),
        sortable: true,
        align: "center",
      })
      .addAction({
        type: ActionType.REFRESH,
        label: "Refresh",
        onClick: () => this.handleRefresh(),
        noSelect: true,
      });
  }

  handleRefresh() {
    return new Promise((res) => {
      this.parent.refreshDashboard();
      res(true);
    });
  }
}
